import { UserStore } from "@/stores/user-store";

/**
 * Resolves the company_site_id of the tenant that matches the active subdomain.
 *
 * Each tenant is a different subdomain, and `companys_sites[].domain` stores the
 * full hostname (same matching used in AppSignIn). Returns `null` when no site
 * matches the current hostname so realtime events from other tenants are ignored.
 */
export function getActiveCompanySiteId(): number | null {
  const user = UserStore.getInstance().value;
  const sites = user?.companys_sites;
  if (!sites?.length) return null;

  const match = sites.find((site) => site.domain === window.location.hostname);
  if (match) return match.id;

  // Single-tenant user: no ambiguity even if the stored domain differs.
  if (sites.length === 1) return sites[0].id;

  return null;
}
